import React, { useRef, useState } from "react";

import { Button, Form } from "semantic-ui-react";

import HeaderCustom from "./HeaderCustom";
import InformationFormBasic, { InformationDataType } from "./InformationFormBasic";
import InformationFormDetailed, { InformationDetailedDataType } from "./InformationFormDetailed";

export type RegisterInformationProps = {
  data: InformationDataType & InformationDetailedDataType;
  layout?: "basic" | "detailed";
  masterData: any;
  masterOptions: any;
  healthFacilityTypeOptions: Record<string, any>[];
  onCancel: () => void;
  onSave: (data: any) => void;
};

const RegisterInformation: React.FC<RegisterInformationProps> = (props) => {
  const [error, setError] = useState<Record<string, any>>({});

  const formRef = useRef<any>(null);

  const handleSave = () => {
    const data = formRef.current.getData();
    const accountName = String(data.accountName || "").trim();

    const requiredFields: string[] = ["accountName"];
    const requiredAddressFields: string[] = [];
    const requiredBusinessFields: string[] = [];

    if (props.layout === "detailed") {
      requiredFields.push("hospital_name");
      requiredAddressFields.push("full_address_text", "province", "district", "city");
      requiredBusinessFields.push("business_type", "tax_payer_id");
      if (data.business.branch_type === "BRANCH") {
        requiredBusinessFields.push("branch_name");
      }
      if (data.business.business_type === "INDIVIDUAL") {
        requiredBusinessFields.push("first_name", "last_name", "branch_type");
      } else if (data.business.business_type === "LEGAL_ENTITY") {
        requiredBusinessFields.push("business_name");
      }
    }

    const missingMainFields = requiredFields.filter((field) => !data[field]);
    const missingAddressFields = requiredAddressFields.filter(
      (field) => !data.division_address?.[field]
    );
    const missingBusinessFields = requiredBusinessFields.filter((field) => {
      const value = data.business?.[field];

      if (field === "branch_type" && value === "") return false;

      return !value;
    });
    const allMissingFields = [
      ...missingMainFields,
      ...missingAddressFields,
      ...missingBusinessFields,
    ];

    let errors: Record<string, any> = accountName.startsWith("@")
      ? { accountName: "ไม่สามารถใช้ @ นำหน้าชื่อได้" }
      : {};

    const taxid = data.business?.tax_payer_id || "";
    const compact = taxid.replace(/ /g, "");

    if (compact.length !== 13 || !/^\d{13}$/.test(compact)) {
      errors.tax_payer_id = true;
    }

    if (allMissingFields.length > 0) {
      errors = { ...errors, ...Object.fromEntries(allMissingFields.map((field) => [field, true])) };
    }

    if (Object.keys(errors).length > 0) {
      setError(errors);

      return;
    }

    props.onSave(data);
    setError({});
  };

  const handleCancel = () => {
    props.onCancel();
  };

  return (
    <>
      <div>
        <Form>
          {props.layout === "detailed" ? (
            <InformationFormDetailed
              ref={formRef}
              detail={props.data}
              error={error}
              masterData={props.masterData}
              masterOptions={props.masterOptions}
              healthFacilityTypeOptions={props.healthFacilityTypeOptions}
            />
          ) : (
            <>
              <HeaderCustom label="สร้าง Official Account" />
              <HeaderCustom label="ข้อมูลการเข้าสู่ระบบ" />

              <InformationFormBasic
                ref={formRef}
                detail={props.data}
                error={error}
                showAccountNameLabel
              />
            </>
          )}
        </Form>
      </div>

      <div style={{ display: "flex", justifyContent: "center", marginTop: "60px" }}>
        {props.layout !== "detailed" && (
          <Button className="primary back" onClick={handleCancel}>
            ยกเลิก
          </Button>
        )}
        <Button className="primary" onClick={handleSave}>
          ยืนยัน
        </Button>
      </div>
    </>
  );
};

export default RegisterInformation;
